import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { CollectionRequestBuilder } from '@web/common';
import { multimediaFromResponse } from '@web/shared/module/multimedia';
import { Guid, isNotNil } from '@web/utils';
import { PublicBrandBannerApiService } from '@web/shared/module/brand';
import { PublicBrandBannerCollectionItem } from '../models/public-brand-banner-collection-item';

@Injectable({
  providedIn: 'root',
})
export class PublicBrandBannerDataSourceService {
  private readonly bannerApi = inject(PublicBrandBannerApiService);
  private readonly collectionRequestBuilder = inject(CollectionRequestBuilder);

  public fetchCollection(options: {
    slug: string;
  }): Observable<PublicBrandBannerCollectionItem[]> {
    const { slug } = options;

    return this.bannerApi
      .fetchCollection({
        cacheable: true,
        request: this.collectionRequestBuilder
          .disablePagination()
          .sorts((builder) => [builder.descendingFor('createdAt').build()])
          .build(),
        slug,
      })
      .pipe(
        map((response) =>
          response.items.map(
            (item) =>
              new PublicBrandBannerCollectionItem({
                file: multimediaFromResponse(item.file),
                id: item.id,
                smallFile: isNotNil(item.smallFile)
                  ? multimediaFromResponse(item.smallFile)
                  : null,
                url: item.url,
              }),
          ),
        ),
        catchError(() => of([])),
      );
  }

  public registerRedirect(options: {
    slug: string;
    id: Guid;
  }): Observable<void> {
    const { id, slug } = options;

    return this.bannerApi
      .registerRedirect({ id, slug })
      .pipe(catchError(() => of(void 0)));
  }
}
